namespace RedBullMOBILE360.CustomerCare {
    @Serenity.Decorators.registerClass()
    export class ManualResumeFraudCasesExcelImportDialog extends Serenity.PropertyDialog<any, any> {
        private form: ManualResumeFraudCasesExcelImportForm;
        public IsDataImported: boolean = false;

        constructor() {
            super();
            this.form = new ManualResumeFraudCasesExcelImportForm(this.idPrefix);
        }

        protected getFormKey() {
            return ManualResumeFraudCasesExcelImportForm.formKey;
        }

        protected getDialogTitle(): string {
            return "Import Data (columns: Msisdn, IdNumber)";
        }

        protected getDialogButtons() {
            let buttons = [];
            buttons.push({
                text: 'Import',
                cssClass: 'export-xlsx-button',
                click: () => {
                    if (!this.validateBeforeSave())
                        return;

                    if (this.form.FileName.value == null ||
                        Q.isEmptyOrNull(this.form.FileName.value.Filename)) {
                        Q.notifyError("Please select a file!");
                        return;
                    }

                    ManualResumeFraudCasesService.ExcelImport({
                        FileName: this.form.FileName.value.Filename
                    }, (response) => {
                        let messageParts = new Array<string>();
                        if (response.Inserted > 0) messageParts.push("Data Saved Successfully: " + response.Inserted);
                        response.ErrorList.forEach((val) => {
                            messageParts.push(val);
                        });

                        Q.information(messageParts.join("\n"), () => { }, { htmlEncode: false });

                        this.IsDataImported = true;
                        this.dialogClose();
                    });
                },
            });
            buttons.push({
                text: 'Cancel',
                click: () => this.dialogClose()
            });
            return buttons;
        }
    }
}
